import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import ListItemDot from 'features/IRWorkstation/components/Common/ListItemDot';
import AcknowledgementInfo from './AcknowledgementInfo';
import { formatDateTime } from 'utils/utils';

const AlertsRow = ({ alert, onClick }) => {
	const isClickable = !!onClick;

	const alertTitle = alert?.event?.event_title || null;
	const alertDetail = alert?.event?.event_detail || null;
	const alertEventTime = alert?.event_time || '';
	const alertSeverity = alert?.severity || 'info';

	const isAcknowledged = alert?.event?.event_status === 'acknowledged';

	const creationDatetime = formatDateTime(alertEventTime);

	const SEVERITY_COLORS = {
		info: 'signal.gray',
		warning: 'signal.amber',
		critical: 'signal.red',
	};

	const EventTitle = ({ title }) => (
		<Typography
			sx={{
				fontSize: '12px',
				color: 'text.primary',
				lineHeight: 1.45,
			}}
		>
			{title}
		</Typography>
	);

	const EventCreation = ({ datetime }) => (
		<Typography
			sx={{
				fontSize: '11px',
				color: 'text.secondary',
			}}
		>
			{datetime}
		</Typography>
	);

	const EventDetail = ({ detail }) => (
		<Typography
			sx={{
				fontSize: '11px',
				color: 'text.secondary',
			}}
		>
			{detail}
		</Typography>
	);

	return (
		<Box
			onClick={onClick}
			sx={{
				display: 'flex',
				alignItems: 'flex-start',
				gap: '9px',
				padding: '9px 15px',
				borderBottom: '0.5px solid',
				borderColor: 'border.light',
				'&:hover': {
					backgroundColor: 'background.subtle',
				},
				cursor: isClickable ? 'pointer' : 'default',
			}}
		>
			<ListItemDot color={SEVERITY_COLORS[alertSeverity]} />

			{/* content */}
			<Box sx={{ flex: 1, minWidth: 0 }}>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'baseline',
						gap: '6px',
					}}
				>
					{alertTitle && <EventTitle title={alertTitle} />}
				</Box>

				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: '6px',
						mt: '2px',
					}}
				>
					{creationDatetime && <EventCreation datetime={creationDatetime} />}

					{creationDatetime && alertDetail ? ' · ' : ''}

					{alertDetail && <EventDetail detail={alertDetail} />}
				</Box>

				{isAcknowledged && (
					<AcknowledgementInfo
						acknowledgedAt={alert?.acknowledged_at}
						acknowledgedByName={alert?.acknowledged_by_name}
					/>
				)}
			</Box>
		</Box>
	);
};

AlertsRow.propTypes = {
	alert: PropTypes.object,
	onClick: PropTypes.func,
};

export default AlertsRow;
